import actionBuilder, { show, create } from 'store/v2/actions';
import actionType, { bulkActionType, apiPath } from './constants';
import request from 'lib/v2/request';
import handleError from 'lib/v1/error-handling';
import { REQUEST_TIMEOUT } from 'config';

const pdf = (id, queryParams = {}) => {
  return show(`${actionType}_PDF`, `${apiPath}/${id}/pdf`, queryParams);
};

const bulkRemind = (payload, silent = false) => {
  return create(actionType, `${apiPath}/bulk/remind`, { ...payload, silent });
};

// Get signature request embed URL for signing
const getSignatureRequestEmbed = (id, timeout = REQUEST_TIMEOUT) => {
  return (dispatch) => {
    dispatch({ type: `GET_${actionType}_EMBED_PENDING` });
    return request
      .get(`${apiPath}/${id}/embed`)
      .timeout(timeout)
      .then((res) => {
        const { data } = res.body;
        dispatch({
          type: `GET_${actionType}_EMBED_SUCCESS`,
          payload: data,
        });
        return { payload: data, success: true };
      })
      .catch((error) => {
        dispatch({ type: `GET_${actionType}_EMBED_FAILURE`, error });
        handleError(error);
      });
  };
};

// Submit a completed signature request
const submitSignatureRequest = (id) => {
  return (dispatch) => {
    dispatch({ type: `SUBMIT_${actionType}_PENDING` });
    return request
      .put(`${apiPath}/${id}/submit`)
      .then(() => {
        dispatch({
          type: `SUBMIT_${actionType}_SUCCESS`,
          payload: { id },
        });
        return { success: true };
      })
      .catch((error) => {
        dispatch({ type: `SUBMIT_${actionType}_FAILURE`, error });
        handleError(error);
      });
  };
};

// Download signature request files
const getSignatureRequestFiles = (id, filename = 'signed_document.pdf') => {
  return (dispatch) => {
    dispatch({ type: `GET_${actionType}_FILES_PENDING` });
    return request
      .get(`${apiPath}/${id}/download`)
      .responseType('blob')
      .then((res) => {
        const blob = res.body;
        if (navigator.msSaveOrOpenBlob) {
          navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        dispatch({ type: `GET_${actionType}_FILES_SUCCESS` });
        return { success: true };
      })
      .catch((error) => {
        dispatch({ type: `GET_${actionType}_FILES_FAILURE`, error });
        handleError(error);
      });
  };
};

const actions = {
  ...actionBuilder({ apiPath, bulkActionType, actionType }),
  pdf,
  bulkRemind,
  getSignatureRequestEmbed,
  submitSignatureRequest,
  getSignatureRequestFiles,
};

export default actions;
